/**
 * Generated runtime TestId mirror for frontend/src/pages/AccountDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const AccountDetailTestIds = {
  accountDetailPage: "account-detail-page",
  accountExternalIdentifier: "account-external-identifier",
  accountStatusBadge: "account-status-badge",
  cardAccountDetails: "card-account-details",
  linkAccountIdentity: "link-account-identity",
  linkAccountSystem: "link-account-system",
  sectionAccountAttributes: "section-account-attributes"
} as const;
